import { useFrame } from '@react-three/fiber';
import { useRef, useState } from 'react';
import { Group } from 'three';

import Tiles, { TilesRef } from '0_canvas/Tiles/Tiles';
import { useThreeStore } from 'state/threeStore';
import useTilesStore from 'state/tilesStore';

import OverAddresScene from '../OverAddresScene/OverAddresScene';
import PerilsScene from '../PerilsScene/PerilsScene';

import useMatrixUpdateHandler from 'hooks/useMatrixUpdateHandler';

const TilesScene = () => {
  const tilesRef = useRef<TilesRef>(null!);
  const tilesSceneRef = useRef<Group>(null);
  const [tilesRendered, setTilesRendered] = useState<boolean>(false);

  useFrame(() => {
    const { place, tiles } = useTilesStore.getState();

    if (!place || !tiles.length) {
      tilesRef.current.reset();
      setTilesRendered(false);

      return;
    }

    tilesRef.current.initialize(place, tiles);

    if (!tilesSceneRef.current) return;
    setTilesRendered(true);

    const {
      tiles: { isRendered },
    } = useThreeStore.getState();

    (tilesSceneRef.current as any).visible =
      isRendered && !!place && tiles.length;
  });

  useMatrixUpdateHandler(
    () => !!useThreeStore.getState().tiles.isRendered,
    tilesSceneRef.current
  );

  return (
    <group ref={tilesSceneRef} visible={false}>
      <Tiles ref={tilesRef} />

      {tilesRendered && (
        <>
          <PerilsScene />
          <OverAddresScene />
        </>
      )}
    </group>
  );
};

export default TilesScene;
